export const hostname =
  window.location.hostname === 'localhost' ? 'dev.scrapex.app' : window.location.hostname;
